import React from "react";
import styled from "@emotion/styled";
import {observer} from "mobx-react";

const Multiplier = styled.span`
	display: inline;
	font-size: 8px;
	padding: 2px 2px 0;
	border-radius: 2px;
	align-items: flex-end;
	background: var(--color3);
	font-weight: 800;
	color: #151b34;
	line-height: 1;
	text-align: center;
	leading-trim: both;
	text-edge: cap;
	font-feature-settings:
		"clig" off,
		"liga" off;
	font-style: normal;
	line-height: 0.9;

	b {
		font-size: 12px;
	}
`;

interface IProps {
	multiplier?: number;
}
export const MultiplierBadge: React.FC<IProps> = observer(({multiplier = 0}) => {
	if (multiplier <= 1) {
		return null;
	}

	return (
		<Multiplier>
			x<b>{multiplier}</b>
		</Multiplier>
	);
});
